import { render, staticRenderFns } from "./SlyderB.vue?vue&type=template&id=2c1f91a9&lang=pug&"
import script from "./SlyderB.vue?vue&type=script&lang=js&"
export * from "./SlyderB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports